module.exports = __webpack_public_path__ + "img/img15.77f48031.png";